import { pLocalStorage } from '@apoly-42/apoly-utils';

export const getLocaleFromLocalStorage = () =>
  pLocalStorage.getItem('localDB.locale');
export const setLocaleToLocalStorage = locale =>
  pLocalStorage.setItem('localDB.locale', locale);
